// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-space-wrap[data-v-38a1694a]{white-space:pre-wrap}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Orders/Show/OrderDetails.vue"],"names":[],"mappings":"AACA,kCACI,oBAAA","sourcesContent":["\n.text-space-wrap {\n    white-space: pre-wrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
